export const ArpeggioStepsLigthsCard = props => {
  const stepsLightsVisible = props.stepsLightsVisible
  const stepsLightsImagesSrc = props.stepsLightsImagesSrc

  return (
    <div className="stepsLightsContainer">
      {stepsLightsVisible.map((step, index) => {
        const className = "arpeggioFullImage visible noContextMenu"
        const src = step ? stepsLightsImagesSrc[1] : stepsLightsImagesSrc[0]
        const alt = step ? "step light on" : "step light off"
        return (
          <div className="arpeggioStepLightContainer" key={index}> 
              <img  draggable="false" className={className} src={src} alt={alt} />
          </div>
        )
      })}
    </div>
  )
}